export default __webpack_public_path__ + "6cad1f69900261e71bf7e566d88c8e31.woff2";